import { render, staticRenderFns } from "./UIBlockVarField.template.vue?vue&type=template&id=42c248b8&scoped=true&"
var script = {}
import style0 from "./UIBlockVarField.template.vue?vue&type=style&index=0&id=42c248b8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c248b8",
  null
  
)

export default component.exports